export default __webpack_public_path__ + "static/media/plane-box-200x200-01-e1569402328635.d8cbb438.png";